<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div>
    <div
      style="
        font-size: 28px;
        text-align: center;
        font-weight: bold;
        margin-bottom: 32px;
      "
    >
      个案处理摘要
    </div>
    <div v-html="html"></div>
    <div
      style="
        font-size: 26px;
        border: 2px dashed #c0bec7;
        margin-top: 32px;
        padding: 24px 32px;
      "
    >
      {{ data_4_1.resultSystem }}
    </div>
  </div>
</template>

<script setup lang="tsx">
import { useTable } from '../../../hooks/use-table';
import { data_4_1 } from '../../../hooks/use-preview';

const props = defineProps<{
  tableHeaderList: any;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();

const className = 'case-table-6';
const attrs = `border='0' bordercolor='#C0BEC7'`;
const { createTable } = useTable(props.tableHeaderList, className, attrs);
const html = createTable(props.tableDataList);
</script>
<style lang="scss">
@import '../../../styles/custom-table.scss';
$border: 2pt solid #c0bec7;
.case-table-6 {
  thead {
    tr {
      th {
        &.empty {
          & + .empty {
            & > div {
              border-left: none;
            }
          }
        }
        & > div {
          border-left: $border;
          border-bottom: $border;
        }
        &:last-child {
          div {
            border-right: $border;
          }
        }
      }
      &:first-child {
        th {
          div {
            border-top: $border;
          }
        }
      }
    }
  }
  tbody {
    tr {
      td {
        &:last-child {
          div {
            border-right: $border;
          }
        }
        & > div {
          border-left: $border;
          border-bottom: $border;
        }
      }
    }
  }
}
</style>
